export function paidFeaturesLive(): boolean {
  const raw = process.env.NEXT_PUBLIC_TIER_BLOCKING?.toLowerCase() ?? "true";
  return ["false", "0", "off", "no"].includes(raw);
}
